import { Box, Image } from '@chakra-ui/react';

import iconhouse from '../../../assets/iconhouse.png';
import iconphone from '../../../assets/iconphone.png';
import iconemail from '../../../assets/iconemail.png';

const AddressIcon = ({ src }: any) => (
  <Box h={'20px'} w={'20px'}>
    <Image src={src} h={'20px'} w={'20px'} />
  </Box>
);

export const HouseIcon = () => <AddressIcon src={iconhouse} />;
export const PhoneIcon = () => <AddressIcon src={iconphone} />;
export const EmailIcon = () => <AddressIcon src={iconemail} />;
